import React from 'react'

const ImgRounded: React.FC = () => {

    return <div>
        <img height={455} width={455} alt='Foto profilo Nicola Sagliano' className='rounded' src='https://s3.eu-west-1.amazonaws.com/nicolasagliano.image/portfolio/profiloKeyboard.webp'></img>
    </div>
}

export default ImgRounded